import React, { useState, useEffect } from 'react';
import useFetch from '../../../hooks/useFetch';
import AccountSelector from './AccountSelector';
import AssessmentSelector from './AssessmentSelector';
import ImplementationSelector from './ImplementationSelector';
import EventSelector from './EventSelector';
import ChatTypeSelector from './ChatTypeSelector';
import DataChart from './DataChart/DataChart';
import DataTable from './DataTable/DataTable';
import processAnalytics from './DataChart/processAnalytics';
import Tabs from '../../../sharedComponents/Tabs';
import specialAnalyticsConfig from './DataChart/processAnalyticsConfig.json'

export default () => {
  const [chartType, setChartType] = useState('Questions');
  
  const [processedAnalytics, setProcessedAnalytics] = useState(false);

  const [isPercentage, setIsPercentage] = useState(true);

  const [selectedAssessmentName, setSelectedAssessmentName] = useState();
  const [selectedAssessmentObj, setSelectedAssessmentObj] = useState({});

  const [hasTags, setHasTags] = useState(false);
  const [hasAggregationGroups, setHasAggregationGroups] = useState(false);

  const chartTypes = ['Questions'];
  if (hasTags) chartTypes.push('Tags');
  if (hasAggregationGroups) chartTypes.push('Aggregations');

  if (!chartTypes.includes(chartType)) {
    setChartType(chartTypes[0])
  }

  const hasProcessedAnalytics = Boolean(specialAnalyticsConfig[selectedAssessmentName]);

  const onAssessementClicked = (assessmentName , assessmentObj = {}) => {
    setSelectedAssessmentName(assessmentName)
    setSelectedAssessmentObj(assessmentObj)
  }

  const fetch = useFetch();

  const [isLoading, setIsLoading] = useState(true)
  const [analyticsData, setAnalyticsData] = useState();

  const [selectedAccount, setSelectedAccount] = useState()

  const [selectedImplementation, setSelectedImplementation] = useState()

  const [selectedEvent, setSelectedEvent] = useState()

  const onSetSelectedImplementation = (obj) => {
    setSelectedImplementation(obj)
    setSelectedEvent(undefined)
  }

  const onSetSelectedEvent = (obj) => {
    setSelectedEvent(obj)
    setSelectedImplementation(undefined)
  }

  useEffect(() => {
    setSelectedImplementation(undefined)
    setSelectedEvent(undefined)
  }, [selectedAccount])

  const selectedAccountId = selectedAccount && selectedAccount.Id ? selectedAccount.Id : '';

  const selectedImplementationId = selectedImplementation && selectedImplementation.Id ? selectedImplementation.Id : '';

  const selectedEventId = selectedEvent && selectedEvent.Id ? selectedEvent.Id : '';

  const fetchAnalyticsAnswersTable = async () => {
    try {
      setIsLoading(true);
      const url = `assessment/analytics/answers?name=${selectedAssessmentName}${selectedAccountId ? `&accountId=${selectedAccountId}` : ''}${selectedImplementationId ? `&implementationId=${selectedImplementationId}` : ''}${selectedEventId ? `&eventId=${selectedEventId}` : ''}`;
      const response = await fetch(url, { method: 'GET' })
      const jsonData = await response.json();
      if (jsonData.error) {
        setAnalyticsData(undefined)
      } else {
        setAnalyticsData(jsonData)
      }
      setIsLoading(false);
    } catch (e) {
      console.log(e)
      setAnalyticsData(undefined)
      setIsLoading(false);
    }
  }

  const fetchAnalyticsData = async () => {
    try {
      setIsLoading(true);
      const url = `assessment/analytics/answerCounts?name=${selectedAssessmentName}${selectedAccountId ? `&accountId=${selectedAccountId}` : ''}${selectedImplementationId ? `&implementationId=${selectedImplementationId}` : ''}${selectedEventId ? `&eventId=${selectedEventId}` : ''}`;
      const response = await fetch(url, { method: 'GET' })
      const jsonData = await response.json();
      if (jsonData.error) {
        setAnalyticsData(undefined)
      } else {
        setAnalyticsData(jsonData)
      }
      setIsLoading(false);
    } catch (e) {
      console.log(e)
      setAnalyticsData(undefined)
      setIsLoading(false);
    }
  }

  const fetchTagsAnalyticsData = async () => {
    try {
      setIsLoading(true);
      const url = `assessment/analytics/tagsAnswerCounts?name=${selectedAssessmentName}${selectedAccountId ? `&accountId=${selectedAccountId}` : ''}${selectedImplementationId ? `&implementationId=${selectedImplementationId}` : ''}${selectedEventId ? `&eventId=${selectedEventId}` : ''}`;
      const response = await fetch(url, { method: 'GET' })
      const jsonData = await response.json();
      if (jsonData.error) {
        setAnalyticsData(undefined)
      } else {
        setAnalyticsData(jsonData)
      }
      setIsLoading(false);
    } catch (e) {
      console.log(e)
      setAnalyticsData(undefined)
      setIsLoading(false);
    }
  }

  const fetchAggregationAnalyticsData = async () => {
    try {
      setIsLoading(true);
      const url = `assessment/analytics/aggregateAnswerCounts?name=${selectedAssessmentName}${selectedAccountId ? `&accountId=${selectedAccountId}` : ''}${selectedImplementationId ? `&implementationId=${selectedImplementationId}` : ''}${selectedEventId ? `&eventId=${selectedEventId}` : ''}`;
      const response = await fetch(url, { method: 'GET' })
      const jsonData = await response.json();
      if (jsonData.error) {
        setAnalyticsData(undefined)
      } else {
        setAnalyticsData(jsonData)
      }
      setIsLoading(false);
    } catch (e) {
      console.log(e)
      setAnalyticsData(undefined)
      setIsLoading(false);
    }
  }

  const finalAnalyticsData = processedAnalytics ? processAnalytics(selectedAssessmentName, analyticsData) : analyticsData;

  const viewTabs = ['Table', 'Graph']
  
  const [selectedViewTab, setSelectedViewTab] = useState('Table')

  useEffect(() => {
    if (selectedAssessmentName) {
      if (selectedViewTab === 'Table') {
        fetchAnalyticsAnswersTable()
      } else {
        if (chartType === 'Questions') {
          fetchAnalyticsData()
        } else if (chartType === 'Aggregations') {
          fetchAggregationAnalyticsData()
        } else {
          fetchTagsAnalyticsData();
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAssessmentName, selectedAccountId, selectedImplementationId, selectedEventId, chartType, selectedViewTab])

  const tabs = ['Implementation', 'Event']
  
  const [selectedTab, setSelectedTab] = useState('Implementation')

  return (
    <div style={{
      flex: 1,
      display: 'flex',
      // padding: '20px'
      // justifyContent: 'center',
      // alignItems: 'center'
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        borderRight: '1px solid #c4c4c4',
      }}>
        <AccountSelector selectedAccount={selectedAccount} setSelectedAccount={setSelectedAccount} />
        <div style={{
          color: '#565656',
          fontSize: '24px',
          fontWeight: 'bold',
          padding: '20px 20px 10px 20px'
        }}>
          {'Type'}
        </div>
        <div style={{ margin: '0px 0px 10px 0px', position: 'relative', left: '-0px' }}>
          <Tabs 
            tabs={tabs} 
            selectedTab={selectedTab} 
            setSelectedTab={setSelectedTab}
            textStyle={{ fontSize: '18px', padding: '8px 0px' }}
            suppressBorderBottom={true} 
            suppressSelectionBorderBottom={true} 
          />
        </div>
        {
          selectedTab === 'Implementation' ?
          <ImplementationSelector accountId={selectedAccount && selectedAccount.Id} selectedImplementation={selectedImplementation} setSelectedImplementation={onSetSelectedImplementation} />
          :
          selectedTab === 'Event' ?
          <EventSelector accountId={selectedAccount && selectedAccount.Id} selectedEvent={selectedEvent} setSelectedEvent={onSetSelectedEvent} />
          :
          <></>
        }
        <AssessmentSelector
          selectedAssessmentName={selectedAssessmentName}
          onAssessementClicked={onAssessementClicked}
          setHasTags={setHasTags}
          setHasAggregationGroups={setHasAggregationGroups}
        />
      </div>

      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}>
        <div style={{ position: 'relative', top: '5px', left: '-10px' }}>
          <Tabs tabs={viewTabs} selectedTab={selectedViewTab} setSelectedTab={setSelectedViewTab} suppressBorderBottom={true} />
        </div>
        {
          selectedViewTab === 'Table' ?
          <div style={{ 
            padding: '20px'
          }}>
            <DataTable
              assessmentData={selectedAssessmentObj}
              analyticsData={finalAnalyticsData} 
              isLoading={isLoading}
              reloadData={fetchAnalyticsAnswersTable}
            />
          </div>
          :
          <>
            <ChatTypeSelector
              isPercentage={isPercentage}
              setIsPercentage={setIsPercentage}
              hasProcessedAnalytics={hasProcessedAnalytics}
              processedAnalytics={processedAnalytics}
              setProcessedAnalytics={setProcessedAnalytics}
              chartType={chartType} 
              setChartType={setChartType}
              chartTypes={chartTypes}
            />
            <DataChart selectedAssessmentName={selectedAssessmentName} analyticsData={finalAnalyticsData} isLoading={isLoading} isPercentage={isPercentage} />
          </>
        }
      </div>

    </div>
  )
}